import styled from 'styled-components';
import { _flex } from 'theme/_mixins/mixins';
import { ColorPalette } from 'theme/colors';

import AirlineImg from 'components/AirlineLogo';
import BaseField from 'components/Field';

export const Field = styled(BaseField)`
  margin-bottom: 16px;
`;

export const Line = styled.div`
  width: 100%;
  padding-top: 32px;
  height: 1px;
  border-bottom: solid 1px ${ColorPalette.HEX.BrightGray};

  @media ${({ theme }) => theme.device.mobile} {
    margin-left: -16px;
    width: calc(100% + 32px);
  }
`;

export const ButtonContainer = styled.div`
  position: sticky;
  bottom: 0;
  background: ${ColorPalette.HEX.White};
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 16px;
  justify-content: space-between;
  margin-top: auto;
  padding: 16px;

  @media ${({ theme }) => theme.device.desktop} {
    max-width: 50%;
    margin-left: auto;
  }
`;

export const SectionDateOfBirth = styled.section`
  padding: 0px 0 48px 0;
  margin-top: -18px;

  @media ${({ theme }) => theme.device.desktop} {
    display: grid;
    grid-template-columns: 1fr 2fr;
    grid-gap: 32px;

    padding-left: 0;
    padding-right: 0;
  }

  @media ${({ theme }) => theme.device.mobile} {
    padding: 0px 16px 32px 16px;
    margin-top: -20px;
  }
`;

export const Content = styled.div`
  @media ${({ theme }) => theme.device.desktop} {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 5px;
  }
`;

export const ErrorValidation = styled.span`
  padding-top: 4px;
  font-size: 12px;
  color: ${({ theme }) => theme.primaryBackgroundColor};
`;

export const LoyaltyWrapper = styled.div`
  ${_flex({ align: 'center' })};
  margin-bottom: 10px;
`;

export const LoyaltyLogo = styled(AirlineImg)`
  width: 20px;
  margin-right: 2px;
  margin-top: -5px;
`;

export const LoyaltyName = styled.span`
  font-size: 16px;
  font-weight: 600;
  color: ${ColorPalette.HEX.PineTree};
  margin-left: 8px;
`;

export const LoyaltyNumber = styled.span`
  font-size: 16px;
  color: ${ColorPalette.HEX.DimGray};
  margin-left: 5px;
`;
